/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

if (document.querySelector("#nos-boutiques") !== null) {
    var shopObserver = new MutationObserver(function (mutationsList, shopObserver) {
        for (var mutation of mutationsList) {
            for (var node of mutation.addedNodes) {
                if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains("stockist-list-result")) {
                    var element = document.getElementById("stockist-widget");
                    const nbStores = element.querySelectorAll(".stockist-result").length;
                    const child = document.querySelector(".stockist-horizontal");
                    child.insertAdjacentHTML("beforebegin", "<div class='stockist-result-count'><span class='stockist-result-count-number'>" + nbStores + "</span> boutiques trouvées</div>");
                    shopObserver.disconnect();
                    return;
                }
            }
        }
    });
    shopObserver.observe(document.body, {childList: true, subtree: true});
}

// Homepage hero arrow href to the next section
if (document.querySelector(".hero__arrow") !== null) {
    const arrow = document.querySelector(".hero__arrow");
    const parent = document.querySelector('[data-section-type="featured-video"]');
    if (parent !== null && parent.parentElement.nextElementSibling !== null) {
        const sectionId = parent.parentElement.nextElementSibling.id;
        arrow.href = "#" + sectionId;
    }
}

// homepage hero video
window.addEventListener("load", function () {
    const videoParent = document.querySelectorAll(".video__player");
    videoParent.forEach(function (parent) {
        const templateContent = parent.querySelector("template").content.firstElementChild.cloneNode(true)
        parent.appendChild(templateContent);
    });
});

window.addEventListener("DOMContentLoaded", function () {
    const GIFT_BAG_STORAGE_KEY = 'giftBagState';
    
    const updateCartAttributes = (giftBagValue) => {
			const formData = new FormData();
			formData.append("attributes[_giftBag]", giftBagValue);
			
			fetch(window.Shopify.routes.root + 'cart/update.js', {
				method: 'POST',
				body: formData
			})
			.then(response => response.json())
			.then(data => console.log(data));
    };


    const gift_bag = document.getElementById("gift_bag");
    
    if (gift_bag) {
        // Si la case est présente, on récupère l'état sauvegardé
        const savedState = localStorage.getItem(GIFT_BAG_STORAGE_KEY);
        if (savedState) {
            gift_bag.checked = savedState === 'true';
        }

        gift_bag.addEventListener("click", function () {
            // Sauvegarder l'état dans le localStorage
            localStorage.setItem(GIFT_BAG_STORAGE_KEY, gift_bag.checked);
            
            // Mettre à jour les attributs du panier
						console.log(gift_bag.checked ? 'Yes' : 'No');
            updateCartAttributes(gift_bag.checked ? 'Yes' : 'No');
        });
    } else {
        // Si la case n'est pas présente, on supprime l'attribut du panier
        // et on réinitialise le localStorage
        localStorage.removeItem(GIFT_BAG_STORAGE_KEY);
        updateCartAttributes('No');
    }
});
